import React, { useState } from "react";
import Img1 from "../assets/images/dirigenti.webp";
import arrowIcon from "../assets/images/Vector_btn.png";
import { ReactComponent as QuoteOpen } from "../assets/images/quote-sx.svg";
import Sezione2popup1 from "./popup/it/sezione-2-popup-1";

const QuoteBlock = ({ children }) => (
  <div className="relative pl-10 pr-10 mb-8 text-[#0E3761] leading-relaxed">
    <QuoteOpen className="absolute left-0 top-0 w-8 h-8 text-[#0E3761]" />
    <p className="text-[20px] md:text-[22px]">{children}</p>

  </div>
);

export default function Sezione2() {

  const [open1, setOpen1] = useState(false);

  return (
    <>
    <div id="sezione-lettere" className="pt-8">

      <div className="w-full xl:w-[1440px] flex flex-col md:flex-row mx-auto  px-4 md:px-5 xl:px-0">
      {/* Colonna Sinistra */}
      <div className="flex justify-center items-end w-full md:w-1/2">
        <img className="w-[100%]" alt="Presidente e General Manager di Reale Group" src={Img1} />
      </div>

      {/* Colonna Destra */}
      <div className="flex items-start flex-col justify-center w-full md:w-1/2 py-6 px-6">
        <h2 className="mb-6 text-[#0E3761]">
          Lettera agli Stakeholder
        </h2>

        <QuoteBlock>
          Il 2025 si è mosso su uno sfondo geopolitico e macroeconomico
          tutt’altro che semplice, eppure Reale Group ha saputo attraversarlo
          con solidità, confermando che un modello fondato sulla mutualità e
          sulla sostenibilità può generare valore durevole - per chi ne fa
          parte e per i territori in cui opera.
        </QuoteBlock>

        <button
          className="bt-secondary flex items-center gap-2"
          onClick={() => setOpen1(true)}
          >
          <img src={arrowIcon} alt="Arrow" className="w-[25px] h-[25px]" />
          Leggi la lettera
        </button>
      </div>

    </div>
    </div>

    {/* Popup lettera (unica, firmata da Presidente e General Manager) */}
    <Sezione2popup1 isOpen={open1} onClose={() => setOpen1(false)} />

    </>
  );
}
